import { render, staticRenderFns } from "./AttractionBanner.vue?vue&type=template&id=5e6453e9&scoped=true&"
import script from "./AttractionBanner.vue?vue&type=script&lang=js&"
export * from "./AttractionBanner.vue?vue&type=script&lang=js&"
import style0 from "./AttractionBanner.vue?vue&type=style&index=0&id=5e6453e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6453e9",
  null
  
)

export default component.exports